import bouncer from 'formbouncerjs/dist/bouncer.min.js';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

let defaultSelector = 'form';
if (window.noDefaultValidation) {
  defaultSelector = '#consultation-modal form';
}
export const validate = bouncer(defaultSelector, {
  disableSubmit: true,
  patterns: {
    tel: en ? /^[0-9\s\(\)\+\-]*$/ : /^[+0][0-9()s-]+$/,
    email: /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/
  },
  messages: {
    missingValue: {
      checkbox: en ? 'required' : 'Pflichtfeld',
      radio: en ? 'required' : 'Pflichtfeld',
      select: en ? 'required' : 'Pflichtfeld',
      'select-multiple': en ? 'Select at least one option' : 'Mindestens eine Option wählen',
      default: en ? 'required' : 'Pflichtfeld'
    },
    patternMismatch: {
      email: en ? 'Invalid email' : 'Ungültige E-Mail-Adresse',
      url: en ? 'Invalid URL' : 'Ungültige URL',
      number: en ? 'Invalid number' : 'Ungültige Zahl',
      date: en ? 'Invalid date' : 'Ungültiges Datum',
      tel: en ? 'Invalid format' : 'Ungültiges Format',
      default: en ? 'Invalid format' : 'Ungültiges Format'
    },
    wrongLength: {
      over: en ? 'Max. {maxLength} characters allowed' : 'Maximal {maxLength} Zeichen erlaubt',
      under: en ? 'At least {minLength} characters required' : 'Mindestens {minLength} Zeichen'
    },
    outOfRange: {
      over: en ? "You can't be older than {max} years." : 'Bitte kein höheres Alter als {max} wählen.',
      under: en ? 'You must be at least {min} years old.' : 'Wir können dich erst ab {min} versichern.'
    },
    isEmpty: () => {
      return en ? 'required' : 'Pflichtfeld';
    },
    notValidName: () => {
      return en ? 'Only Latin characters and European special characters allowed' : 'Nur lateinische Buchstaben und europäische Sonderzeichen erlaubt';
    },
    underMinAge: field => {
      const age = field.dataset.bouncerMinAge;
      return en ? `You must be at least ${age} years old.` : `Du musst mindestens ${age} Jahre alt sein.`;
    },
    overMaxAge: field => {
      const age = field.dataset.bouncerMaxAge;
      return en ? `You can't be older than ${age} years.` : `Du kannst nicht älter als ${age} Jahre sein.`;
    }
  },
  customValidations: {
    isEmpty: field => {
      if (!field.hidden && (!field.value || field.value.trim() === '')) {
        field.value = '';
        field.dispatchEvent(new Event('update'));
        return field.required;
      }
      return false;
    },
    underMinAge: field => {
      if (!field.value || field.type !== 'text' || !field.hasAttribute('data-bouncer-min-age')) {
        return false;
      }
      return dayjs().diff(dayjs(field.value, 'DD.MM.YYYY'), 'year') < parseInt(field.dataset.bouncerMinAge);
    },
    overMaxAge: field => {
      if (!field.value || field.type !== 'text' || !field.hasAttribute('data-bouncer-max-age')) {
        return false;
      }
      return dayjs().diff(dayjs(field.value, 'DD.MM.YYYY'), 'year') >= parseInt(field.dataset.bouncerMaxAge);
    },
    notValidName: field => {
      if (!field.value || field.type !== 'text' || !['first_name', 'last_name'].includes(field.name)) {
        return false;
      }
      return !/^(?:[\p{Script=Latin}\s'-]+)$/u.test(field.value);
    }
  }
});

// FORM TRIGGER on JOBS PAGE
export const validateJob = bouncer('form.jobform', {
  disableSubmit: true,
  patterns: {
    tel: /^[+0][0-9\(\)\s-]+$/,
    email: /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
  },
  messages: {
    missingValue: {
      select: en ? 'required' : 'Bitte wählen',
      file: en ? 'Upload at least one CV but no more than 5 files total.' : 'Bitte mindestens den Lebenslauf hochladen. Insgesamt nicht mehr als fünf Dateien.',
      default: en ? 'required' : 'Pflichtfeld'
    },
    patternMismatch: {
      email: en ? 'Invalid email' : 'Ungültige E-Mail-Adresse',
      tel: en ? 'Invalid format' : 'Ungültiges Format',
      url: en ? 'Invalid URL' : 'Ungültige URL',
      number: en ? 'Invalid number' : 'Ungültige Zahl',
      date: en ? 'Invalid date' : 'Ungültiges Datum',
      default: en ? 'Invalid format' : 'Ungültiges Format'
    },
    wrongLength: {
      over: en ? 'Max. {maxLength} characters allowed' : 'Maximal {maxLength} Zeichen erlaubt',
      under: en ? 'At least {minLength} characters required' : 'Mindestens {minLength} Zeichen'
    },
    isEmpty: () => {
      return en ? 'required' : 'Pflichtfeld';
    },
    notValidName: () => {
      return en ? 'Only Latin and European special characters allowed' : 'Nur lateinische Buchstaben und europäische Sonderzeichen erlaubt';
    },
    moreThanFiveFiles: () => {
      return en ? 'Upload no more than 5 files total.' : 'Du kannst nicht mehr als fünf Dateien hochladen.';
    },
    wrongFileType: () => {
      return en
        ? 'Wrong file format – only pdf, docx, doc, jpg, jpeg, png, txt, ods, odt, rtf are allowed'
        : 'Falsches Dateiformat – erlaubt sind nur pdf, docx, doc, jpg, jpeg, png, txt, ods, odt, rtf';
    },
    noFile: () => {
      return en ? 'Upload at least one CV' : 'Bitte mindestens einen Lebenslauf hochladen';
    }
  },
  customValidations: {
    isEmpty: field => {
      if (!field.hidden && (!field.value || field.value.trim() === '')) {
        field.value = '';
        field.dispatchEvent(new Event('update'));
        return field.required;
      }
      return false;
    },
    notValidName: field => {
      if (!field.value || field.type !== 'text' || !['first_name', 'last_name'].includes(field.name)) {
        return false;
      }
      return !/^(?:[\p{Script=Latin}\s'-]+)$/u.test(field.value);
    },
    moreThanFiveFiles: field => {
      return field.type == 'file' && document.querySelectorAll('#list > div').length > 5;
    },
    wrongFileType: field => {
      return [...document.querySelectorAll('#list > div')].some(el => el.classList.contains('fileerror'));
    },
    noFile: field => {
      return field.type == 'file' && !document.querySelectorAll('#list > div').length;
    }
  }
});

// FORM TRIGGER on MAGAZINE HOME
export const validateSearch = bouncer('form.search', {
  disableSubmit: false,
  customValidations: {
    isEmpty: function (field) {
      return field.value.length === 0;
    }
  },
  messages: {
    isEmpty: en ? 'Please enter a search term.' : 'Bitte einen Suchbegriff eingeben.',
    wrongLength: {
      under: en ? 'At least 3 characters required.' : 'Mindestens drei Zeichen eingeben.'
    }
  }
});

document.addEventListener('bouncerShowError', function (event) {
  event.target.removeAttribute('aria-invalid');
});
